import React from 'react';

const HomePage = ({ onNavigate }) => {
  const gameOptions = [
    {
      key: 'quick-match',
      icon: '⚡',
      title: 'Quick Match',
      description: 'Find players instantly',
      action: () => onNavigate('matchmaking')
    },
    {
      key: 'create-room',
      icon: '🏠',
      title: 'Create Room',
      description: 'Create a private game room',
      action: () => onNavigate('create-room')
    },
    {
      key: 'join-room',
      icon: '🚪',
      title: 'Join Room',
      description: 'Join an existing game room',
      action: () => onNavigate('join-room')
    }
  ];

  return (
    <div className="home-container">
      <h1 className="home-title">🎲 Ludo Multiplayer</h1>
      <p className="home-subtitle">
        Play the classic board game online with friends and players from around the world!
      </p>
      
      <div className="home-buttons">
        {gameOptions.map((option) => (
          <button
            key={option.key}
            className="home-button"
            onClick={option.action}
          >
            <span className="icon">{option.icon}</span>
            <div className="title">{option.title}</div>
            <div className="description">{option.description}</div>
          </button>
        ))}
      </div>

      <div style={{ marginTop: '40px', color: 'rgba(255, 255, 255, 0.8)' }}>
        <p>🎯 Play with 2-4 players</p>
        <p>🎲 Roll the dice and move your pieces</p>
        <p>💬 Real-time chat during games</p>
        <p>🏆 Be the first to get all pieces home!</p>
      </div>
    </div>
  );
};

export default HomePage;